module.exports = __webpack_public_path__ + "static/media/originar-sustentabilidade.73d4321a.png";